import { ServiceIconSize } from "@zapier/design-system";
import { AppImages } from "../types";

const getAppIconUrl = (
  appId: string,
  images: AppImages | undefined,
  size: ServiceIconSize,
) => {
  let key;
  switch (size) {
    case "xx-small": {
      key = "url_16x16" as const;
      break;
    }

    case "x-small": {
      key = "url_32x32" as const;
      break;
    }

    case "small": {
      key = "url_64x64" as const;
      break;
    }

    case "medium": {
      key = "url_64x64" as const;
      break;
    }

    default: {
      key = "url_128x128" as const;
      break;
    }
  }

  const fallback = appId ? `/generated/${appId.replace("CLIAPI", "")}/64` : "";

  return images ? images[key] : fallback;
};

export default getAppIconUrl;
